/**
 * Where the InGo API is. **No default, on purpose** (InGo mobile plan §3, M0):
 * a missing address fails loudly instead of quietly reaching production, which
 * is what the Supabase fallbacks did (`AGENTS.md`, hazard 1).
 *
 * `REACT_APP_API_URL` is the API's root including `/api/v1`, for example
 * `http://127.0.0.1:8190/api/v1` on this machine or the staging VPS's HTTPS
 * address for a phone. It is baked into the bundle at build time.
 *
 * Read by its full name, never as `process.env` whole: CRA replaces a bare
 * `process.env` with an object of every `REACT_APP_` variable, so the whole
 * environment lands in the bundle (`npm run check:*` refuses such a build).
 */
export class ApiNotConfiguredError extends Error {
  constructor() {
    super('The InGo API address is not set. Put REACT_APP_API_URL in .env.local (see .env.example).');
    this.name = 'ApiNotConfiguredError';
  }
}

/** The configured root without a trailing slash, or `''` when none is set. */
export function configuredApiUrl(raw = process.env.REACT_APP_API_URL) {
  return String(raw || '').trim().replace(/\/+$/, '');
}

export function isApiConfigured(raw = process.env.REACT_APP_API_URL) {
  return configuredApiUrl(raw) !== '';
}

/** The root every request is built on. Throws rather than guess. */
export function apiBaseUrl(raw = process.env.REACT_APP_API_URL) {
  const url = configuredApiUrl(raw);

  if (url === '') {
    throw new ApiNotConfiguredError();
  }

  return url;
}
